/**
 * Resolve an image field that can be either a URL (http/https), a data URI,
 * or raw base64 bytes stored in a BLOB column.
 */
export function resolveImage(raw: string | null | undefined, mimeType?: string | null): string | null {
  if (!raw) return null;
  if (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('data:')) return raw;
  return `data:${mimeType || 'image/jpeg'};base64,${raw}`;
}
